import { EditableCard } from "../../../components/editableCard.component";
import { ProfileCardPlaceholder } from "../../../components/placeholders.component";
import { ApiSchemaPatient } from "../../../models/api";
import { AppRouteUi, AppRouteApi } from "../../../config/appRoute";
import { useParams } from "react-router";
import { Image } from "../../../components/image.component";

type Props = {
  data: ApiSchemaPatient | undefined;
  isValidating: boolean;
};

export const ProfileCard = (props: Props) => {
  const { patientId } = useParams<{ patientId: string }>();
  return (
    <EditableCard
      link={`${AppRouteUi.Patient.Root()}/update/${patientId}`}
      title="Patient Profile"
      className="mb-3"
      isValidating={props.isValidating}
      showEditButton
      showBackButton
    >
      {props.isValidating ? (
        <ProfileCardPlaceholder />
      ) : (
        <div className="d-flex align-items-center">
          <div>
            <Image
              src={
                props.data?.profilePic
                  ? AppRouteApi.Media.ByPath(props.data.profilePic)
                  : "/img/admin-profile.svg"
              }
              alt="Profile"
              className="p-3 rounded-circle object-fit-cover"
              width={150}
              height={150}
            />
          </div>
          <div className="ms-5">
            <h1 className="display-6">
              {props.data?.firstName} {props.data?.lastName}
            </h1>
          </div>
        </div>
      )}
    </EditableCard>
  );
};
